var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getOrganizationMap } from '../../../../ui/features/organizations/utils/getOrganizationMap';
import { useContactManagementTranslation } from '../../../../ui/hooks/useContactManagementTranslation';
import { useFilterConfig } from '@juvare/common-data-table-ui/FiltersBar';
export function useUserDirectoryFilterConfig({ extendFilters }) {
    const { t } = useContactManagementTranslation();
    return useFilterConfig((builder) => {
        builder.quickSearchFilter({
            dataPath: 'partialSearch',
            label: t('common.searchByNameOrEmail'),
            sx: { maxWidth: { xs: undefined, sm: 340 } },
            dataTest: 'search-input',
        });
        const stateFilter = builder.quickFilterSelect({
            dataPath: 'state',
            label: t('common.state'),
            valueProvider: 'classifier.state',
            widget: 'form.select',
            sx: { maxWidth: { xs: undefined, sm: 340 } },
            dataTest: 'state-filter',
        });
        builder.allFiltersPanel({
            key: '!identityInformation', // This key can be used by other products to extend/modify account filters.
            label: t('panels.accounts.filterLabels.identityInformation'),
            children: [
                builder.allFiltersWidget({
                    type: 'form.text',
                    key: 'firstName',
                    label: t('panels.accounts.filterLabels.firstName'),
                    emptyAsNull: true,
                }),
                builder.allFiltersWidget({
                    type: 'form.text',
                    key: 'lastName',
                    label: t('panels.accounts.filterLabels.lastName'),
                }),
                builder.allFiltersWidget({
                    type: 'form.email',
                    key: 'email',
                    label: t('panels.accounts.filterLabels.email'),
                }),
                builder.allFiltersWidget({
                    type: 'form.phone',
                    key: 'contactPhoneNumber',
                    label: t('panels.accounts.filterLabels.phoneNumber'),
                }),
                builder.allFiltersWidget({
                    type: 'form.text',
                    key: 'pagerNumber',
                    label: t('panels.accounts.filterLabels.pagerNumber'),
                    validate: {
                        custom: (value) => {
                            if (value == null || /^\d{10}$/.test(value)) {
                                return;
                            }
                            return t('panels.accounts.filterValidationError.pagerNumber');
                        },
                    },
                }),
            ],
            style: {
                columns: 2,
            },
        });
        builder.allFiltersPanel({
            key: '!location', // This key can be used by other products to extend/modify account filters.
            label: t('panels.userDirectory.filterLabels.locationInformation'),
            children: [
                builder.allFiltersWidget({
                    type: 'form.text',
                    key: 'city',
                    label: t('common.city'),
                }),
                builder.allFiltersWidget({
                    type: 'form.text',
                    key: 'postalCode',
                    label: t('common.zipCode'),
                }),
                stateFilter,
                builder.allFiltersWidget({
                    type: 'form.select',
                    key: 'county',
                    label: t('common.county'),
                    valueProvider: {
                        type: 'classifier.county',
                        paramsFromFormData: 'state',
                    },
                }),
            ],
            style: {
                columns: 2,
            },
        });
        builder.allFiltersPanel({
            key: '!orgMembership', // This key can be used by other products to extend/modify account filters.
            label: t('panels.accounts.filterLabels.orgMembership'),
            children: [
                builder.allFiltersWidget({
                    type: 'contactManagement.organizationSharing',
                    key: 'orgAssociation',
                    showSelectAllChildren: true,
                    includeByOrgPermission: ['manage-members'],
                }, (filterData) => __awaiter(this, void 0, void 0, function* () {
                    if (filterData.orgAssociation) {
                        const organizationMap = yield getOrganizationMap(filterData.orgAssociation);
                        return filterData.orgAssociation.map((staticOrganizationId) => {
                            var _a;
                            return ({
                                label: (_a = organizationMap[staticOrganizationId].columns.name) !== null && _a !== void 0 ? _a : 'Organization',
                                value: staticOrganizationId,
                                groupId: staticOrganizationId,
                                onRemoveChip: (prevFilterData, value) => {
                                    const newFilterData = JSON.parse(JSON.stringify(prevFilterData));
                                    if (newFilterData.orgAssociation) {
                                        newFilterData.orgAssociation = newFilterData.orgAssociation.filter((v) => v !== value);
                                        if (newFilterData.orgAssociation.length === 0) {
                                            delete newFilterData.orgAssociation;
                                        }
                                    }
                                    return newFilterData;
                                },
                            });
                        });
                    }
                    else {
                        return [];
                    }
                })),
            ],
        });
        extendFilters === null || extendFilters === void 0 ? void 0 : extendFilters(builder);
    }, [t, extendFilters]);
}
